import api from '../utils/api';

export const getDistrictSiteUsers = (districtid) => {
    return api({
        url: '/api/districtaccount/get-all/' + (districtid ?? ''),
        method: 'GET',
    });
}

export const submitDistrictSiteUser = (districtSiteUser) => {
    let url = '/api/districtaccount/add';
    return api.post(url, districtSiteUser);
}

export const editDistrictSiteUser = (districtSiteUser) => {
    let url = '/api/districtaccount/edit';
    return api.post(url, districtSiteUser);
}

export const deleteDistrictSiteUser = (districtId, siteUserId) => {
    return api({
        url: `/api/districtaccount/delete/${districtId}/${siteUserId}`,
        method: 'DELETE',
    });
};

export const getUsers = () => {
    return api({
        url: '/api/adminusers/get-all',
        method: 'GET',
    })
}

export const getAllUsers = () => {
    return api({
        url: '/api/adminusers/get-all-users-list',
        method: 'GET',
    })
}


export const getDistrictSiteUsersV2 = (districtid) => {
    return api({
        url: '/api/districtaccount/get-all-v2/' + (districtid ?? ''),
        method: 'GET',
    });
}

export const submitDistrictSiteUserV2 = (districtSiteUser) => {
    let url = '/api/districtaccount/add-v2';
    return api.post(url, districtSiteUser);
}

export const editDistrictSiteUserV2 = (districtSiteUser) => {
    let url = '/api/districtaccount/edit-v2';
    return api.post(url, districtSiteUser);
}
export const getAllSchoolUsersByDistrictId = (districtId) => {
    return api({
        url: `/api/districtaccount/get-all-schools-users/${districtId}`,
        method: 'GET',
    });
}
export const getAllReviewers = (districtid) => {
    return api({
        url: `/api/adminusers/get-all-reviewers/${districtid}`,
        method: 'GET',
    })
}

export const addExistingDealer = (districtId, siteUserId) => {
    const url = `/api/districtaccount/add-existing-dealer/${districtId}/${siteUserId}`;
    return api.post(url);
};